/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('ServerControllersServiceApi', ($http, ApiErrorService) => {
    return {
        getAll: getAll,
        getActiveServerControllers: getActiveServerControllers,
        repoConnectionCheck: repoConnectionCheck,
        getById: getById,
        save: save,
        getSimulatorsUsingServerControllerWithId: getSimulatorsUsingServerControllerWithId
    };
    function getAll() {
        return $http.get(`api/ServerControllers`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getActiveServerControllers() {
        return $http.get(`api/ServerControllers/GetAll/Active`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function repoConnectionCheck(id) {
        return $http.get(`api/ServerControllers/repoCheck?id=${id}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getById(id) {
        return $http.get(`api/ServerControllers/${id}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function save(serverController) {
        return $http.post(`api/ServerControllers`, serverController)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorsUsingServerControllerWithId(serverControllerId) {
        return $http.get(`api/ServerControllers/${serverControllerId}/Simulators`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
